import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'female-japanese-diet',
	landing: {
		ids: ['loader-japanese-diet'],
		route: {
			path: '/japanese-diet-f',
			name: 'female-japanese-diet-funnel',
		},
	},
	funnel: {
		id: 'ob-female-japanese-diet',
		route: {
			path: '/japanese-diet-f/ob/:page(.*)?',
			name: 'female-japanese-diet',
		},
		slug: 'female-japanese-diet',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-japanese-diet-f',
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-f'],
	},
}

export default appAreaConfig
